import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { MetalTypeEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';

export default function* watchGetPendingStockOutListing(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('approval/approvalGetPendingStockOutListingAttempt', handleGetPendingStockOutListing, api);
}

function* handleGetPendingStockOutListing(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        index,
        filters: {
            dateFrom,
            dateTo,
            branchName,
            metalType,
        },
    } = reduxState.approval.pendingStockOutListing;

    const allBranches = reduxState.branch.allBranches;

    const branchCode = allBranches.find(branch => branch.branchName === branchName)?.branchCode;

    if (!index && index !== 0) {
        yield put(combinedActions.approvalGetPendingStockOutListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        return;
    }

    const response = yield* call([api, api.getStockOutListing], {
        authToken,
        index,
        dateFrom: dateFrom ? dateFrom : undefined,
        dateTo: dateTo ? dateTo : undefined,
        metalType: metalType ? UtilFunctions.Misc.getEnumValueByKey(MetalTypeEnum, metalType) : undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.approvalGetPendingStockOutListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.approvalGetPendingStockOutListingSuccess({
            index: response.data.index,
            maxIndex: response.data.maxIndex,
            data: response.data.stockOuts,
        }));
        return;
    }
}
